"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var stripe_js_1 = require("@stripe/stripe-js");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var react_router_1 = require("react-router");
var react_redux_1 = require("react-redux");
require("./payment_form.scss");
var PaymentCard_1 = require("./PaymentCard");
var actions_1 = require("../../store/payment/actions");
var axios_1 = require("../../utils/axios");
var reducer_1 = require("../../store/payment/reducer");
var ApplePay_1 = require("../../components/Icons/ApplePay");
var CardPay_1 = require("../../components/Icons/CardPay");
var actions_2 = require("../../store/cart/actions");
var PaymentButtons_1 = require("./PaymentButtons");
var stripePromise;
if (window.stripePubKey && window.stripeAccount) {
    stripePromise = (0, stripe_js_1.loadStripe)(window.stripePubKey, { apiVersion: '2020-08-27', stripeAccount: window.stripeAccount });
}
var currency = 'gbp';
var methodType = reducer_1.PaymentMethodType.card;
var PaymentForm = function (_a) {
    var total = _a.total;
    var dispatch = (0, react_redux_1.useDispatch)();
    var restaurantId = (0, react_router_1.useParams)().restaurant;
    var searchParams = new URLSearchParams(location.search);
    var type = searchParams.get('type') || '';
    var tableQuery = searchParams.get('table') || '';
    var _b = (0, react_redux_1.useSelector)(function (state) { return ({
        cart: state.cart,
        paymentTab: state.cart.paymentTab,
    }); }), cart = _b.cart, paymentTab = _b.paymentTab;
    var onChangePaymentTab = function (tab) { return dispatch((0, actions_2.cartChangeAttribute)('paymentTab', tab)); };
    var createPaymentIntentRequest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, actions_1.fetchPaymentIntentRequest)());
                    data = {
                        cart: cart,
                        type: type || (tableQuery ? 'dinein' : ''),
                        restaurant_id: restaurantId,
                        currency: currency,
                        method_type: methodType,
                        payment_method_id: null,
                    };
                    return [4, (0, axios_1.post)('/api/stripe/payment_intent', data)
                            .then(function (res) {
                            var data = res.data;
                            dispatch((0, actions_1.fetchPaymentIntentSuccess)(data));
                            return data;
                        })
                            .catch(function (err) {
                            var _a;
                            var message = ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message) || 'Please, try again later';
                            return dispatch((0, actions_1.fetchPaymentIntentFailure)(message));
                        })];
                case 1:
                    response = _a.sent();
                    return [2, response];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(react_stripe_js_1.Elements, __assign({ stripe: stripePromise }, { children: [(0, jsx_runtime_1.jsxs)("ul", __assign({ className: "payment-list" }, { children: [(0, jsx_runtime_1.jsxs)("li", __assign({ className: (0, classnames_1.default)('payment-list-card payment-list-card-google', { 'payment-list-card-active': paymentTab === 1 }), onClick: function () { return onChangePaymentTab(1); } }, { children: [(0, jsx_runtime_1.jsx)(ApplePay_1.ApplePay, {}), (0, jsx_runtime_1.jsx)("span", { children: " Google/Apple Pay" })] })), (0, jsx_runtime_1.jsxs)("li", __assign({ className: (0, classnames_1.default)('payment-list-card payment-list-card-standard', { 'payment-list-card-active': paymentTab === 0 }), onClick: function () { return onChangePaymentTab(0); } }, { children: [(0, jsx_runtime_1.jsx)(CardPay_1.CardPay, {}), (0, jsx_runtime_1.jsx)("span", { children: "Credit/Debit Card" })] }))] })), paymentTab === 0 ? (0, jsx_runtime_1.jsx)(PaymentCard_1.PaymentCard, { createPaymentIntentRequest: createPaymentIntentRequest, total: total }) : (0, jsx_runtime_1.jsx)(PaymentButtons_1.PaymentButtons, { createPaymentIntentRequest: createPaymentIntentRequest, total: total })] })));
};
exports.PaymentForm = PaymentForm;
exports.default = exports.PaymentForm;
